export class ProviderSetupRequest {
    name: string;
    businessName: string;
    billingEmail: string;
    token: string;
    key: string;
}
